import store from '@/store';
import transform from 'lodash/transform';
import { stringify } from 'query-string';
import { getBootId } from '@/libs/utils/boot';
import { get, cloneDeep } from 'lodash';

function report(reqUrl) {
  try {
    let img = new Image(1, 1);
    img.src = reqUrl;
    img.onload = () => {
      img = null;
    };
  } catch (err) {
    // eslint-disable-next-line
    console.log(err);
  }
}

// 获取是设备类型：雷石 雷客
function getDeviceType(roomStat) {
  if (!roomStat) {
    return 'ls';
  }
  if (roomStat.includes('_dev=lk')) {
    return 'lk';
  }
  return 'ls';
}

function getCommonParams() {
  const params = {
    openid: store.state.openid,
    unionid: store.state.unionid,
    ktvid: store.state.ktvid,
    ktv_id: store.state.ktvid,
    roomid: store.state.roomid,
    room_id: store.state.roomid,
    roomip: store.state.room_ip,
    room_ip: store.state.room_ip,
    fr: store.state.user_scan_fr,
    tp: '',
    desc: '',
    isolduser: store.state.is_old_user,
    is_vip: store.state.is_vip,
    is_cc: store.state.ccTotal,
    is_expired_vip: store.state.is_expired_vip,
    type: getDeviceType(store.state.room_stat),
    _r: Math.random(),
    t: Date.now(),
    track_id: getBootId(),
  };
  return params;
}
// const url = require('url');
// category:类型，比如点击，必填，；
// tp:交互事件，要有具体页面比如首页点歌、首页跳转VIP等，百度统计的action类型；必填；
// action: 交互事件，要有具体页面比如首页点歌、首页跳转VIP等，和tp统一值；必填；
// desc:事件具体描述，用于内部统计，比如点击切换榜单, 必填；
// optLabel：点击的具体标签,比如banner， 可选；
export const reportktv = (logData) => {
  let params = getCommonParams()
  if (logData.event_str) {
    params = Object.assign(params, logData.event_str)
  }
  if (logData.str1) {
    params.str1 = `${logData.str1}`;
  }
  params.str10 = store.state.role // str10用于上报用户身份
  if (logData.event_type) {
    params.tp = `${logData.event_name}`;
    const optLabel = transform(logData.event_data, (labelStr, value) => {
      labelStr.push(value);
      return labelStr;
    }, []);
    params.desc = optLabel.filter((label) => !!label).join('|') || '';
    // macid
    if (get(logData, 'event_data.macid', false)) {
        params.macid = logData.event_data.macid
    }
  } else {
    params.tp = logData.tp;
    params.desc = logData.desc;
    params = Object.assign(params, logData);
  }
  let host = process.env.NODE_ENV === 'production'
    ? '//log6.ktvsky.com'
    : '';
  const sendUrl = `${host}/wx/vadd/user?${stringify(params)}${store.state.room_stat}`;
  report(sendUrl);
};

export const reportHmt = (logData) => {
  const originLog = cloneDeep(logData);
  // TODO 扩展基础字段
  if (originLog.event_type) {
    originLog.event_data = {
      ...originLog.event_data,
      is_vip: store.state.is_vip ? 'vip' : '非vip',
    };
    const optLabel = transform(originLog.event_data, (labelStr, value) => {
      labelStr.push(value);
      return labelStr;
    }, []);
    _hmt.push(['_trackEvent', originLog.event_type, originLog.event_name, optLabel.join('|') || '']);
    return;
  }
  // @ts-ignore
  _hmt.push(['_trackEvent', originLog.category, originLog.tp, originLog.optLabel || 'thunder']);
};

export const reportPay = (logData) => {
  const commonParams = getCommonParams();
  if (typeof logData.page_tp === 'string' && !logData.page_tp.includes('role')) {
    logData.page_tp = `${logData.page_tp}_${store.state.role}`
  }
  const src = `https://log6.ktvsky.com/user/action?${stringify({
    ...logData,
    ...commonParams,
    tp: 3,
  })}`;
  report(src);
};

// /vadd/user/v2
export const reportVaddUser = (log) => {
  const originLog = cloneDeep(log);
  if (!['点歌', '顶部通告栏'].includes(originLog.event_name)) return;
  if (!originLog.event_type) return;
  const commonParams = getCommonParams();
  if (originLog.event_tp) {
    commonParams.tp = originLog.event_tp
  }
  const event_data = get(originLog, 'event_data', {});

  if (originLog.event_data) {
    delete originLog.event_data;
  }

  const logData = {
    ...originLog,
    ...event_data,
  };

  const sendHost = 'http://log6.ktvsky.com/vadd/user/v2';
  const sendUrl = `${sendHost}?${stringify(commonParams)}&${stringify(logData)}`;
  report(sendUrl);
};

// 用于统计 支付 流程路径打点
// https://m2miovoqda.feishu.cn/wiki/wikcn5fJuQAaEg24EqVXbt4jSbf
export const reportVaddA3PayReport = (log) => {
  const originLog = cloneDeep(log);
  const event_data = get(originLog, 'event_data', {});

  if (originLog.event_data) {
    delete originLog.event_data;
  }
  const logData = {
    ...originLog,
    ...event_data,
  };
  const commonParams = getCommonParams()
  const sendHost = 'http://log6.ktvsky.com/vadd/A3/pay/report';
  const sendUrl = `${sendHost}?${stringify(commonParams)}&${stringify(logData)}`;
  report(sendUrl);
}

// 用户流量数据打点，用于分析 用户操作流程以及相关分析
// https://m2miovoqda.feishu.cn/wiki/wikcngQdxAzQASQUBrgoKewoWsg
export const reportVaddA3RequestReport = (log) => {
  const originLog = cloneDeep(log);
  const event_data = get(originLog, 'event_data', {});

  if (originLog.event_data) {
    delete originLog.event_data;
  }
  const logData = {
    ...originLog,
    ...event_data,
  };
  const commonParams = getCommonParams()
  const sendHost = 'http://log6.ktvsky.com/vadd/A3/request/report';
  const sendUrl = `${sendHost}?${stringify(commonParams)}&${stringify(logData)}`;
  report(sendUrl);
}
// /vod/event
export const reportEvent = (log) => {
  const params = {
    _src: 300000,
    ktv_id: store.state.ktvid,
    _mac: store.state.Mac,
    roomid: store.state.roomid,
    intranet_ip: store.state.room_ip,
    _user_id: store.state.unionid,
    _ts: Date.now(),
  }
  const host = process.env.NODE_ENV !== 'development'
    ? '//log6.ktvsky.com'
    : '';
  const sendUrl = `${host}/vod/event?${stringify(log)}&${stringify(params)}`;
  report(sendUrl);
}
